import { useState } from "react";
import { LayoutGrid, Sparkles } from "lucide-react";
import AivoryOnePanel from "@/components/AivoryOnePanel";
import AivoryOneWorkspace from "@/components/AivoryOneWorkspace";

export default function AivoryOneDock({ aiEnabled = true, eventId = null }) {
  const [open, setOpen] = useState(false);
  const [workspaceOpen, setWorkspaceOpen] = useState(false);
  const [panelKey, setPanelKey] = useState(0);
  const [hasStage, setHasStage] = useState(false);

  if (workspaceOpen) {
    return (
      <AivoryOneWorkspace
        aiEnabled={aiEnabled}
        eventId={eventId}
        onClose={() => setWorkspaceOpen(false)}
      />
    );
  }

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid="aivory-one-open"
        aria-expanded={open}
        aria-label={open ? "Close AivoryONE (Beta)" : "Open AivoryONE (Beta)"}
        className={`fixed z-[60] right-0 top-1/2 -translate-y-1/2 flex flex-col items-center justify-center gap-2 py-5 px-2 rounded-l-xl shadow-lg border border-r-0 transition-all duration-200 ${
          open ? "bg-[var(--bg-surface)] text-[var(--primary)] border-[var(--border-default)]" : "bg-[var(--primary)] text-[var(--on-primary,#fff)] border-[var(--primary)] hover:brightness-105"
        }`}
        style={{ writingMode: "vertical-rl", textOrientation: "mixed" }}
      >
        <Sparkles size={14} className="shrink-0" style={{ transform: "rotate(90deg)" }} />
        <span className="text-[10px] font-mono font-semibold uppercase tracking-[0.2em]">AivoryONE (Beta)</span>
      </button>

      <div className={`fixed z-[59] inset-y-0 right-0 flex justify-end pointer-events-none transition-[visibility] duration-300 ${open ? "visible" : "invisible delay-300"}`} aria-hidden={!open}>
        <button type="button" className={`absolute inset-0 bg-black/20 pointer-events-auto transition-opacity duration-300 ${open ? "opacity-100" : "opacity-0"}`} aria-label="Close AivoryONE (Beta)" onClick={() => setOpen(false)} />
        <aside
          data-testid="aivory-one-dock"
          className={`relative pointer-events-auto flex flex-col h-full max-h-[100dvh] m-0 sm:m-3 sm:mr-14 sm:h-[calc(100dvh-1.5rem)] sm:max-h-[calc(100dvh-1.5rem)] sm:rounded-2xl overflow-hidden border border-[var(--border-default)] bg-[var(--bg-surface)] shadow-2xl transition-transform duration-300 ease-out ${
            open ? "translate-x-0" : "translate-x-full"
          } ${hasStage ? "w-[min(100vw,760px)]" : "w-[min(100vw,420px)]"}`}
        >
          <div className="flex items-center justify-end gap-2 px-3 py-2 border-b border-[var(--border-default)]">
            <button
              type="button"
              className="inline-flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-widest text-[var(--text-tertiary)] hover:text-[var(--primary)]"
              onClick={() => { setOpen(false); setWorkspaceOpen(true); }}
              data-testid="aivory-one-expand-workspace"
            >
              <LayoutGrid size={12} /> Workspace
            </button>
          </div>
          <AivoryOnePanel
            key={panelKey}
            variant="dock"
            aiEnabled={aiEnabled}
            eventId={eventId}
            onStageChange={setHasStage}
            onClose={() => setOpen(false)}
            onNewChat={() => { setPanelKey((k) => k + 1); setHasStage(false); }}
          />
        </aside>
      </div>
    </>
  );
}
